var React = require('react');

function KeypadUnlock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.476 12.952c.89 0 1.62-.728 1.62-1.619 0-.89-.73-1.619-1.62-1.619-.89 0-1.619.729-1.619 1.62 0 .89.729 1.618 1.62 1.618zm4.857-7.285H1.62C.729 5.667 0 6.395 0 7.286v8.095C0 16.271.729 17 1.619 17h9.714c.89 0 1.62-.729 1.62-1.619V7.286c0-.89-.73-1.62-1.62-1.62zm-2.428 0v-1.62A4.05 4.05 0 0 1 12.952 0 4.05 4.05 0 0 1 17 4.048h-1.538a2.512 2.512 0 0 0-2.51-2.51 2.512 2.512 0 0 0-2.51 2.51v1.619H8.906zm2.428 9.714H1.62V7.286h9.714v8.095z","fill":"currentColor"}));
}

KeypadUnlock.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17"};

module.exports = KeypadUnlock;

KeypadUnlock.default = KeypadUnlock;
